import React from 'react';
import './CallToAction.css';
import { useSectionView } from '../hooks/useSectionView';
import { sendEvent } from '../analytics';

const CallToAction = () => {
  const scrollToFeatures = () => {
    const featuresElement = document.getElementById('features-section');
    if (featuresElement) {
      featuresElement.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="cta-section" className="cta-section">
      {useSectionView('cta', 'cta-section')}
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">
            Klaar om uw ruimtelijke project te realiseren?
          </h2>
          
          <div className="cta-description">
            <p>Professioneel advies op maat voor planologische kansen.</p>
            <p>Van concept tot realisatie, wij denken mee in uw plannen.</p>
          </div>
          
          <div className="cta-buttons">
            <button className="cta-button primary" onClick={() => { try { sendEvent('click_cta', { cta_id: 'cta_primary_services', location: 'cta' }); } catch (_) {} scrollToFeatures(); }}>
              Bekijk onze diensten
              <svg className="button-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.33334 8H12.6667M12.6667 8L8.00001 3.33333M12.6667 8L8.00001 12.6667" 
                      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            <button className="cta-button secondary" onClick={() => { try { sendEvent('click_cta', { cta_id: 'cta_secondary_plan_gesprek', location: 'cta' }); } catch (_) {} }}>
              Plan een gesprek
              <svg className="button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="2" y="3" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M6 1v4M10 1v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M2 7h12" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
